import React from 'react';
import { Popover, PopoverBody, PopoverHeader } from 'reactstrap';
import { PropTypes } from 'prop-types';
import { StandardButton, StandardButtonType } from '@payer-admin-ui/components-v2/src/buttons/StandardButton';
import { PayerErrorMessage } from './PayerErrorMessage';

const ErrorPopover = ({ target, body, onClose }) => (
  <Popover target={target} isOpen={!!body}>
    <PopoverHeader className="text-danger">
      Something went wrong.
      <StandardButton type={StandardButtonType.CLOSE} sx={{ p: '.3rem', m: '-.5rem' }} onClick={onClose} />
    </PopoverHeader>
    <PopoverBody>{body}</PopoverBody>
  </Popover>
);

ErrorPopover.propTypes = {
  target: Popover.propTypes.target,
  body: PropTypes.node,
  onClose: PropTypes.func.isRequired,
};

const PayerErrorPopover = ({ target, error, onClose }) =>
  error ? (
    <ErrorPopover
      target={target}
      body={React.isValidElement(error) ? error : <PayerErrorMessage error={error} />}
      onClose={onClose}
    />
  ) : null;

PayerErrorPopover.propTypes = {
  target: ErrorPopover.propTypes.target,
  error: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.shape({
      code: PropTypes.string,
      message: PropTypes.string,
      stack: PropTypes.string,
    }),
  ]),
  onClose: PropTypes.func.isRequired,
};

export { ErrorPopover, PayerErrorPopover };
